import classNames from 'classnames';

import { Markdown } from '~components/Markdown';
import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';

import styles from './ContentBlockTextBgColor.module.scss';
import {
  BgColor,
  ContentBlockTextBgColorProps,
} from './ContentBlockTextBgColor.types';

export function ContentBlockTextBgColor({
  text,
  bgColor = BgColor.Stroke,
  ...sectionProps
}: ContentBlockTextBgColorProps) {
  return (
    <ContentBlockWrapper {...sectionProps}>
      <article className={classNames(styles.container, styles[bgColor])}>
        <Markdown markdownString={text} />
      </article>
    </ContentBlockWrapper>
  );
}
